// Generated with util/create-component.js
import TabList from './TabList';

export default TabList;
